import { connect } from 'react-redux'
import {changeLabel,selectFamousActivities,fetchFamousRace} from '../actions'
import FamousRacesList from '../components/FamousRacesList'

const mapStateToProps = (state) => {
    return state;
}

const mapDispatchToProps = (dispatch) => {
    return {
        onChangeLabel: (key,value) => {
            dispatch(changeLabel(key,value));
        },
        onSelectFamousActivities: (activities,indices) => {
            dispatch(selectFamousActivities(activities,indices));
        },
        onFetchFamousRace:(id)=>{
            dispatch(fetchFamousRace(id))
        },
    }
}

const RxFamousRacesList = connect(
    mapStateToProps,
    mapDispatchToProps
)(FamousRacesList)

export default RxFamousRacesList


// WEBPACK FOOTER //
// ./src/containers/RxFamousRacesList.js